module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTMyMCA2NzJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6IG0tMTkyIDB2NjRoNjR2LTY0SDEyOHogbTE5Mi0xOTJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6IG0tMTkyIDB2NjRoNjR2LTY0SDEyOHogbTE5Mi0xOTJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6TTEyOCAyODh2NjRoNjRWMjg4SDEyOHoiIGZpbGw9IiMwIiBwLWlkPSI4NTEiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/List-outlined.svg
// module id = ypDe
// module chunks = 75